import React from 'react';
import { SettingsPage } from '../../components/SettingsPage/SettingsPage';
import { SettingsCategory } from '../../config/SettingsCategory';
import { useSettingsPage } from '../../hooks/useSettingsPage';
import { SettingsRenderer } from '../../SettingsProvider/SettingsRenderer';

interface MouseSettingsPageProps {
	title: string;
	description?: string;
}

export const MouseSettingsPage: React.FC<MouseSettingsPageProps> = ({ title }) => {
	const { settingsState, availableSettingIds, handleChangeBySettingId } = useSettingsPage(
		{
			category: SettingsCategory.Mouse,
			defaultValue: true,
		}
	);

	return (
		<SettingsPage
			title={title}
			settings={
				<>
					{/* Dynamically render all available settings */}
					{availableSettingIds.map((settingId) => (
						<SettingsRenderer
							key={settingId}
							settingId={settingId}
							settingsState={settingsState}
							handleChange={handleChangeBySettingId}
						/>
					))}
				</>
			}
		/>
	);
};
